import React, { useState } from 'react';
import styles from './PortfolioLightbox.module.css';
import { X, ChevronLeft, ChevronRight } from 'lucide-react';

const PortfolioLightbox = ({ portfolioItem, onClose }) => {
    const [currentImageIndex, setCurrentImageIndex] = useState(0);

    if (!portfolioItem) {
        return null;
    }

    const { title, description, mediaUrl } = portfolioItem;

    const handlePrevImage = () => {
        setCurrentImageIndex((prevIndex) => (prevIndex === 0 ? mediaUrl.length - 1 : prevIndex - 1));
    };

    const handleNextImage = () => {
        setCurrentImageIndex((prevIndex) => (prevIndex === mediaUrl.length - 1 ? 0 : prevIndex + 1));
    };

    return (
        <div className={styles.lightboxOverlay} onClick={onClose}>
            <div className={styles.lightboxContent} onClick={(e) => e.stopPropagation()}>
                <button className={styles.closeButton} onClick={onClose}>
                    <X size={32} />
                </button>
                <div className={styles.imageViewer}>
                    <button className={styles.navButton} onClick={handlePrevImage}>
                        <ChevronLeft size={48} />
                    </button>
                    <img src={mediaUrl[currentImageIndex]?.url} alt={`${title} - image ${currentImageIndex + 1}`} className={styles.mainImage} />
                    <button className={styles.navButton} onClick={handleNextImage}>
                        <ChevronRight size={48} />
                    </button>
                </div>
                <div className={styles.thumbnails}>
                    {mediaUrl.map((media, index) => (
                        <img
                            key={media.id}
                            src={media.url}
                            alt={`${title} - thumbnail ${index + 1}`}
                            className={`${styles.thumbnail} ${index === currentImageIndex ? styles.activeThumbnail : ''}`}
                            onClick={() => setCurrentImageIndex(index)}
                        />
                    ))}
                </div>
                <div className={styles.details}>
                    <h3 className={styles.title}>{title}</h3>
                    <p className={styles.description}>{description}</p>
                </div>
            </div>
        </div>
    );
};

export default PortfolioLightbox;
